// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { isDevMode } from "@angular/core";
import { Store } from "../../src/app/@core/store/store";

export const environment = {
  production: true,
  departments: window["env"].departments,
  boardofdirectors: window["env"].boardofdirectors,
  myteamsv2: window["env"].myteams,
  alina: window["env"].alina,
  approval: window["env"].approval,
  fileUpload: true,
  showForex: window["env"].showForex,
  CMSURL_IMG: window["env"].CMS_URL_IMG,
  eventTrack: true,
  empFeedBack: true,
  showAttendanceV2: true,
   showAttendanceV3: true,
  attendanceV2: true,
  weatherNew: true,
  LINA_NAME: 'LEINA',
  KYL_access:false,
  quiz_access:true,
  townhall:true,
  showQuizNotify:false,
  showTownhallNotify:true,
  isHeadersDisable:true,
  quizDailyPopup: true,
  showCms: true,
  localStorage: {
    key: "ltts",
  },
  api: {
    core: {
      base: window["env"].apiUrl,
      cmsBase: window["env"].cmsUrl,
      base2: window["env"].api2Url,
      base3: "/be/api",
      base4: "https://mylttsqa.ltts.com/be/api/",
    } as Store.APIConfig,
    auth: {
      me: {
        endpoint: "profile/me",
      },
      validate: {
        endpoint: "/auth/validate",
      },
      forgotPassword: {
        endpoint: "/auth/superadmin/forgot-password",
      },
      verifyOtp: {
        endpoint: "/auth/otp/token",
      },
      verifyEmail: {
        endpoint: "/auth/superadmin/verify-email",
      },
      changePassword: {
        endpoint: "/user/change-password/",
      },
    } as Store.APIConfigGroup,
    session: {
      login: {
        endpoint: "/auth/login",
      },
      token: {
        endpoint: "/auth/token",
      },
      tokenRefresh: {
        endpoint: "/token/refresh",
      },
      logout: {
        endpoint: "/auth/logout",
      },
      loadUserConfiguration: {
        endpoint: "config/userSettings/{employeeId}",
      },
    },
    cmsapi: {
      stock: {
        endpoint: "/get-stock",
      },
      news: {
        endpoint: "/fetch-latest-news",
      },
      quote: {
        endpoint: "/daily-quote",
      },
    },
    cms: {
      hero: {
        endpoint: "post/hero",
      },
      spotlight: {
        endpoint: "post/spotlight",
      },
      post: {
        endpoint: "post/postsWithpagenation/",
      },
      segments: {
        endpoint: "post/segments",
      },
      announcements: {
        endpoint: "post/announcements",
      },
    },
    declaration: {
      EmployeeRelationsGetStatus: {
        endpoint: "EmployeeRelation/save-status",
      },
      EmployeeRelationsUpdate: {
        endpoint: "EmployeeRelation/update-status",
      },
      EmployeeRelationsDeclaration: {
        endpoint: "EmployeeRelation/submit-declaration",
      },
      EmployeeRelationsCheckStatus: {
        endpoint: "EmployeeRelation/check-declaration-submitted",
      },
      EmployeeRelationsGetCategories: {
        endpoint: "EmployeeRelation/relationship-categories",
      },
      EmployeeRelationsConflictTypes: {
        endpoint: "EmployeeRelation/conflict-types",
      },
      EmployeeRelationsConflictQuestions: {
        endpoint: "EmployeeRelation/conflict-questions",
      },
      EmployeeRelationsMyDeclarations: {
        endpoint: "EmployeeRelation/my-declarations",
      },
      EmployeeRelationsDeclarationStatus: {
        endpoint: "EmployeeRelation/declaration-status",
      },
      EmployeeRelationsAddRelatedMember: {
        endpoint: "EmployeeRelation/add-related-member",
      },
      EmployeeRelationsRelativeDataValidation: {
        endpoint: "EmployeeRelation/relativedatavalidation",
      },
      EmployeeRelationsAdminAccess: {
        endpoint: "EmployeeRelation/relationship-admin-access",
      },
      EmployeeRelationsExportAllDeclarations: {
        endpoint: "EmployeeRelation/export-all-declarations",
      },
    },
    applications: {
      getAllApplications: {
        endpoint: "app/app-launcher",
      },
      addToFavourite: {
        endpoint: "app/favourite-app",
      },
      addToRecentlyAccessed: {
        endpoint: "app/recently-visited",
      },
      removeFromFavourite: {
        endpoint: "/app/un-fav",
      },
    },
    profile: {
      userProfile: {
        endpoint: "profile?emailId={empId}",
      },
    },
    weatherForecast: {
      endpoint: "config/forecast/{city}",
    },
    weatherDetails: {
      endpoint:
        "config/weatherdetails?city={city}&Lattitude={Lattitude}&Longitude={Longitude}",
    },
    intranet: {
      feeds: {
        endpoint: "/segments",
      },
      approvalRequests: {
        endpoint: "ticket/getApprovalRequests?emailId={emailId}",
        // endpoint: 'ticket/getApprovalRequests/emailId'
      },
      attendanceApprovalRequest: {
        endpoint: "ticket/getApprovalRequests/attendance?emailId={emailId}",
      },
      leaveApprovalRequest: {
        endpoint: "ticket/getApprovalRequests/leave?emailId={emailId}",
      },
      carApprovalRequest: {
        endpoint: "ticket/getApprovalRequests/car?emailId={emailId}",
      },
      accommodationApprovalRequest: {
        endpoint: "ticket/getApprovalRequests/accommodation?emailId={emailId}",
      },
      SynergyPendingRequest: {
        endpoint: "synergy/pendingrequests?userEmail={emailId}",
      },
      forexRequest: {
        endpoint: "ticket/getforexpendingrequest?emailId={emailId}",
      },
      approveRequest: {
        endpoint: "ticket/request-approve",
      },
      declineRequest: {
        endpoint: "ticket/request-decline",
      },
      forexApproval: {
        endpoint: "ticket/forex/approve?forexId={forexId}",
      },
      myOrganization: {
        endpoint: "org/daily-overview?userId={userEmail}",
      },
      myOrganizationDatewise: {
        endpoint:
          "org/daily-overview/date?userId={userEmail}&overviewDate={overviewDate}",
      },
      myOrganizationMonthwise: {
        endpoint:
          "org/daily-overview/month?userId={userEmail}&overviewDate={overviewDate}",
      },
      myAttendance: {
        endpoint: "my-schedule",
      },
      myAttendanceNew: {
        endpoint: "my-schedule/my-attendance",
      },
      myDailyAttendance: {
        endpoint: "my-schedule/my-attendance/daily",
      },
      dailyAttendance: {
        endpoint: "my-schedule/my-attendanceV2/daily",
      },
      myTeams: {
        endpoint: "team",
      },
      widgetOrder: {
        endpoint: "widget/updateWidgetOrder/{userId}",
      },
      leadership: {
        endpoint: "/leadership",
      },
      myRequest: {
        endpoint: "Requests/Attendance-requests?employeeId={employeeId}",
      },
      telemetry: {
        endpoint: "telemetry/event",
      },
    },
    townHallEvents: {
        ApproveAnonymous:{
        endpoint:'Event/unapprovedanonymousquestions'
      },
      rejectQuestion: {
   endpoint: 'Event/Reject-Question'
      },
      approveQuestion:{
        endpoint:'Event/Approve-Question'
      },
      downloadQuestion: {
        endpoint: "/Event/download-questions-csv?eventId=",
      },
      fetchDropdown: {
        endpoint: "Event/DropDownValues",
      },
      createEvent: {
        endpoint: "Event/create",
      },
      updateEvent: {
        endpoint: "Event/update",
      },
      fetchAllEvents: {
        endpoint: "Event/active",
      },
      fetchActiveEventsEmployee: {
        endpoint: "Event/employee/active",
      },
      fetchPastEventsEmployee: {
        endpoint: "Event/employee/past",
      },
      fetchFutureEventEmployee: {
        endpoint: "Event/employee/future",
      },
      deleteEvent: {
        endpoint: "Event/deactivate/{eventId}",
      },
      eventData: {
        endpoint: "Event/eventinfo",
      },
      addQuestion: {
        endpoint: "Event/Ask-Question",
      },
      addAnswer: {
        endpoint: "Event/Answer",
      },
      allQuestion: {
        endpoint: "Event/QuestionAnswers",
      },
      eventReaction: {
        endpoint: "Event/answer-feedback",
      },
      eventQuestionReaction: {
        endpoint: "Event/question-feedback",
      },
      publicToggle: {
        endpoint: "Event/ToggleQuestionPrivacy",
      },
      answeredQuestion: {
        endpoint: "Event/AnsweredQuestions",
      },
      UnansweredQuestion: {
        endpoint: "Event/UnansweredQuestions",
      },
      editAnswer: {
        endpoint: "Event/Update-Answer",
      },
    },
     contentUpload: {
      fetchCategory:{
        endpoint: 'post/categories'
      },
      uploadContent:{
        endpoint: 'post/upload-post'
      },
      editContent:{
        endpoint: 'post/edit-post?postId={postId}'
      },
      getAllContent:{
         endpoint: 'post/GetAllPosts'
      },
      getAllContentById:{
         endpoint: 'post/FetchPostById/26'
      },
      approveContent:{
        endpoint: 'post/post/approve'
      },
      publishContent:{
        endpoint: 'post/post/publish'
      },
      approveandPublishContent:{
        endpoint: 'post/post/Approvepublish'
      },
      teamsDropdown:{
        endpoint:'post/cmsteams'
      }
    },
    applicationSearch: {
      endpoint: "/search/all?query={searchQuery}",
    },
    bingsearch: {
      endpoint: "search/people?query={searchQuery}",
    },
    feedBack: {
      moodSubmit:{
        endpoint: "FeedBack/Submit"
      },
      checkFeedbackSubmitted:{
        endpoint: "/ModernIntranet/check-userfeedback-submitted"
      },
      filter:{
        endpoint:"/FeedBack/drop-downV2"
      },
      feedBackData:{
        endpoint:"/FeedBack/feedback-filtration"
      },
      lineChartData: {
        endpoint: "/FeedBack/feedback-trends"
      },
      heatmap:{
        endpoint:"/FeedBack/heatmap"
      }
      
    },
    dynamicStack: {
      endpoint: "dynamic-stack/userId",
      remindersData: {
        endpoint: "dynamic-stack-reminders/?userId={userId}",
      },
      announcements: {
        endpoint: "/announcements",
      },
      calendarConsent: {
        endpoint: "profile/update-calendar-consent",
      },
      getCalendarEvents: {
        endpoint: "graph/calendar-events",
      },
    },
    widget: {
      citydetails: {
        endpoint: "config/cityList/{city}",
      },
      citycode: {
        endpoint: "config/latLong/{placeid}",
      },
    },
    myteam: {
      employeeDetails: {
        endpoint:
          "team-members/profile?userId={userId}&employeeId={employeeId}",
      },
      getCoreTeam: {
        endpoint: "team",
      },
      getProjectData: {
        endpoint: "project/get-list?currentPageNumber={page}&userId={user}",
      },
      getCoreTeamV2: {
        endpoint:
          "my-team/direct-reportees?managerPsNo={employeeId}&currentPage={currentPage}&pageSize={pageSize}&searchTerm={searchTerm}",
      },
      getProjectDataV2: {
        endpoint:
          "my-team/project-team?psNo={employeeId}&nameFilter={nameFilter}",
      },
      getProfileImage: {
        endpoint: "profile/profileImage",
      },
    },
    genie: {
      trackGuest: {
        endpoint: "chat/track?session_id={uuid}",
      },
      postChat: {
        endpoint: "chat/",
      },
      fetchChatHistory: {
        endpoint: "chat/sessions",
      },
      chatBot: {
        endpoint: "api/chat",
      },
      history: {
        endpoint: "api/chat/history/{email}",
      },
      session: {
        endpoint: "api/chat/history/session/{session_id}/{email}",
      },
      speak: {
        endpoint: "api/chat/text-to-speech",
      },
      speechToText: {
        endpoint: "api/chat/speech-to-text",
      },
      loadText: {
        endpoint: "ws/chat-proxy",
      },
      promptData: {
        endpoint: "api/chat/prompt-tree",
      },
      upload: {
        endpoint: "file/upload",
      },
    },
    buddy: {
      chat: {
        endpoint: "/api/chat/stream",
      },
      ws: {
        endpoint: "api/ws/chat2",
      },
    },
  },

  formats: {
    date: {
      // Moment JS date formats
      default: "MM-DD-YYYY",
      long: "D-MMM-YYYY",
      short: "D-MMM-YYYY",
    },
    dateTime: {
      // Moment JS date formats
      default: "MM-DD-YYYY HH:mm:ss",
    },
  },

  msalConfig: {
    auth: {
      clientId: '666344ba-e20c-4b2a-a411-ed6d4fd58ac4', // Your client ID from Azure AD
      authority: window["env"].tenantId, // Your tenant ID from Azure AD
      redirectUri: window["env"].redirectUri, // The redirect URI configured in Azure AD
      // postLogoutRedirectUri: 'https://localhost:4200/auth/login'
    },
  },
  apiConfig: {
    // scopes: [
    //   "api://261b35cb-fd59-46a8-bb15-59d637817589/app",
    //   "https://graph.microsoft.com/Calendars.Read",
    //   "https://graph.microsoft.com/Calendars.ReadWrite",
    // ],
    // uri: "https://graph.microsoft.com/v1.0/me/events",
    scopes: ["api://myltts.ltts.com/666344ba-e20c-4b2a-a411-ed6d4fd58ac4/app"],
    uri: "",
  },

  //RIDDELL urls
  // msalConfig: {
  //   auth: {
  //     clientId: "883823fa-4e28-4c74-acde-e7bb77bb12c2",
  //     authority:
  //       "https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize",
  //     redirectUri: "https://localhost:4200/dashboard",
  //     // redirectUri: "https://riddell-dev.lrmer.com/dashboard",
  //   },
  // },
  // apiConfig: {
  //   scopes: ["api://883823fa-4e28-4c74-acde-e7bb77bb12c2/app"],
  //   uri: "",
  // },
};

if (!isDevMode()) {
  environment.api.core.base = window["env"].apiUrl;
  environment.api.core.cmsBase = window["env"].cmsUrl;
}
